import PageGeneral from 'components/pages/general';
import { fetchContentPayload } from 'lib/contentful/api';
import { CORE_SECTIONS_FRAGMENT } from 'components/sections';
import { SEO_FRAGMENT } from 'components/SEO';
import addGlobalModule from 'lib/contentful/addGlobalModule';
import addSections from 'lib/contentful/addSections';
import { asyncPipe } from 'lib/utils/helpers';
import getLayoutItems from 'lib/contentful/getLayoutItems';
import getPaths from 'lib/storeLocales/staticPaths/getPaths';
import withStoreLocales from 'lib/storeLocales/staticPaths/withStoreLocales';
import withStoreLocale from 'lib/storeLocales/staticProps/withStoreLocale';
import getCurrency from 'lib/storeLocales/getCurrency';
import withoutSlugs from 'lib/utils/withoutSlugs';
import getStoreLocaleSlugs from 'lib/storeLocales/staticProps/getStoreLocaleSlugs';
import parseLocaleSlugs from 'lib/storeLocales/staticProps/parseLocaleSlugs';
import generateChannableFeed from 'lib/generateChannableFeed';
import isBuilding from 'lib/isBuilding';

export const getStaticProps = withStoreLocale(
  async ({ params, preview = false, previewData = null, locale, store }) => {
    const { slug, isApp = false } = params;

    const currency = getCurrency(store);

    const corePage = await fetchContentPayload(
      {
        query: `
      query page($slug: String!, $locale: String, $preview: Boolean) {
        pageGeneralCollection(limit: 1, where: { slug: $slug }, locale: $locale, preview: $preview) {
          items {
            sys {
              id
            }
            slug
            headerTransparent
            ${CORE_SECTIONS_FRAGMENT}
            ${SEO_FRAGMENT}
            globalModule {
              sys {
                id
              }
              name
            }
          }
        }
      }
    `,
        variables: { slug, locale, preview },
      },
      preview
    ).then(r => r?.pageGeneralCollection?.items[0]);

    if (!corePage)
      return {
        notFound: true,
      };

    const page = await asyncPipe(
      addSections(locale, preview),
      addGlobalModule(locale, preview, currency)
    )(corePage);

    const storeLocaleSlugs = await getStoreLocaleSlugs(page.sys.id, 'pageGeneral', '', preview);
    const localeSlugs = parseLocaleSlugs(store, storeLocaleSlugs);

    return {
      props: {
        previewData,
        isApp,
        page: {
          ...page,
          seo: { ...(page.seo || {}), localeSlugs },
        },
        ...(isApp
          ? {}
          : await getLayoutItems(locale, preview, store).then(l => ({
              ...l,
              storeLocaleSelector: { ...l.storeLocaleSelector, storeLocaleSlugs },
            }))),
        locale,
        currency,
        store,
      },
    };
  }
);

export const getStaticPaths = withStoreLocales(async ({ locales, storeLocales }) => {
  if (isBuilding) {
    console.log('Channable feed generating in [getStaticPaths] of [pages/[slug].jsx]');
    await generateChannableFeed();
  }

  return {
    paths: withoutSlugs({
      remove: ['not-found'],
      from: await getPaths(
        storeLocales,
        locales,
        `query pages($locale: String) {
        pageGeneralCollection(where: { slug_exists: true, slug_not: "/" }, locale: $locale, limit: 1000) {
          items {
            slug
          }
        }
      }`
      ),
    }),
    fallback: false,
  };
});

export default PageGeneral;
